import React from 'react'
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'

import CreateEditLocation from './CreateEditLocation'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import {
    fetchLocation,
    fetchLocationError,
    createLocation,
    updateLocation,
    errorLocation,
    fetchLocationsList
} from './actions'


import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './Locations.css'

var Spinner = require('react-spinkit');

let chkReturn = 0;
let chkViewReturn = 0;

const formatTime = (timeString, isClose) => {
    if (!timeString || timeString.indexOf(':') < 0)
        return timeString;
    
    const timeParts = timeString.split(':');

    if (isClose)
        timeParts[0] = (parseInt(timeParts[0]) - 12).toString();

    if (parseInt(timeParts[0]) < 10 && timeParts[0].length > 1)
        timeParts[0] = timeParts[0].substring(1);
    
    return timeParts.join(':');
}

class Locations extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nameSrch: '',
            location: {
                addressId: 0,
                addressLine1: "",
                addressLine2: null,
                city: "",
                displayOrder: "",
                email: "",
                fax: "",
                hub: "",
                id: 0,
                ip: "",
                isClosed: false,
                isClosedNotes: "",
                latitude: "",
                locationDescription: null,
                locationGroupId: 0,
                locationHoursNotes: "",
                locationPageDescription: "",
                locationPageMetaDescription: "",
                locationPageMetaTitle: "",
                locationPagePublished: false,
                locationPageTitle: "",
                locationPageUrl: "",
                longitude: "",
                name: "",
                pc: "",
                phone: "",
                reicoId: "",
                stateCode: "",
                stateId: 0,
                team: "",
                virtualTourLink: "",
                weekdayHours: "",
                weekendHours: "",
                zip: "",
                openingHours: {
                    weekdays: {
                        opens: "",
                        closes: ""
                    },
                    saturday: {
                        opens: "",
                        closes: ""
                    },
                    sunday: {
                        opens: "",
                        closes: ""
                    }
                }
            },
            editLocationMode: false
         };

        this.afterOpen = this.afterOpen.bind(this);

        this.search = this.search.bind(this);

        this.fetchLocationErrorClear = this.fetchLocationErrorClear.bind(this);
        this.errorLocationClear = this.errorLocationClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.locationView = this.locationView.bind(this);

        this.locationEdit = this.locationEdit.bind(this);
        this.locationEditVerify = this.locationEditVerify.bind(this);

        this.locationCreate = this.locationCreate.bind(this);
        this.updateLocation = this.updateLocation.bind(this);
        this.updateLocationHours = this.updateLocationHours.bind(this);

        this.cancelLocation = this.cancelLocation.bind(this);
        this.closeLocation = this.closeLocation.bind(this);

        this.locationCheck = this.locationCheck.bind(this);

        this.pageDescriptionChange = this.pageDescriptionChange.bind(this);
    }

    afterOpen() {
        if (this.state.editLocation) {
            let loc = this.state.location

            loc.locationPageDescription = this.props.location.location.locationPageDescription;
            this.setState({location: loc})
        }

        if (this.state.viewLocation) {
            $('span.req-msg').css('display', 'none')

            $('input, select, textarea').each(function () {
                $(this).attr('disabled', 'disabled')
            })
            
            setTimeout(function () {
                $(document.getElementsByTagName('iframe')[0].contentDocument.getElementsByTagName('body')).css('background', '#ebebe4')
                $(document.getElementsByTagName('iframe')[0].contentDocument.getElementsByTagName('body')).attr('contenteditable', 'false')
            }, 500)
        }
        else this.locationCheck()
    }

    locationCheck() {
        let location_good = true

        if ($('input#locationPagePublished').is(':checked')) {
            $('input').each(function () {
                const id = $(this).attr('id');

                if (id != 'name'
                 && id != 'isClosed'
                 && id != 'addressLine2'
                 && !id.includes('OpenTime')
                 && !id.includes('CloseTime')) {
                    if ($(this).val() == '') {
                        location_good = false;
                        $(this).addClass('input-error');
                    }
                    else {
                        $(this).removeClass('input-error');
                    }
                }
            })

            $('select').each(function () {
                if ($(this).val() == 'Select') {
                    location_good = false;
                    $(this).addClass('input-error')
                }
                else {
                    $(this).removeClass('input-error')
                }
            })

            if (!this.state.location.locationPageDescription.length) {
                location_good = false
                $('div.mce-edit-area').css('border', '1px solid red')
            }
            else {
                $('div.mce-edit-area').css('border', 'none')
                $('div.mce-edit-area').css('border-top', '1px solid #c5c5c5')
            }
        }
        else
        {
            $('input, select, textarea').each(function () {
                if ($(this).attr('id') != 'name_2' && $(this).attr('id') != 'locationGroupId' && $(this).attr('id') != 'stateCode') {
                    $(this).removeClass('input-error')
                }
                else if ($(this).val() == '' || $(this).val() == 'Select') {
                    $(this).addClass('input-error')
                    location_good = false;
                }
                else
                    $(this).removeClass('input-error')
            })

            $('div.mce-edit-area').css('border', 'none')
            $('div.mce-edit-area').css('border-top', '1px solid #c5c5c5')
        }

        $('#locationPageMetaDescriptionCounter').text($('#locationPageMetaDescription').val().length.toString() + ' characters')
        $('#locationPageMetaTitleCounter').text($('#locationPageMetaTitle').val().length.toString() + ' characters')

        if (location_good) {
            $('span.req-msg').css('display', 'none')
            $('button.btn-primary').removeAttr('disabled')
        }
        else {
            $('span.req-msg').css('display', 'inline')
            $('button.btn-primary').attr('disabled', 'disabled')
        }
    }

    fetchLocationErrorClear() {
        this.props.dispatch(fetchLocationError);
    }

    errorLocationClear(e) {
        this.props.dispatch(errorLocation);

        if (this.props.location.error === "409") {
            let id = e.target.attributes.location.value;

            fetchLocation.bind(this)(id);
        }
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    search(e) {
        this.setState({ nameSrch: e.target.value.toLowerCase() })
    }

    locationView(e) {
        if (this.props.locations.fetching) return

        this.setState({ viewLocation: true })
        this.locationEdit(e)
    }
 
    locationEdit(e) {
        if (chkReturn || this.props.locations.fetching ) return;
        chkReturn = 1;

        let id = e.target.attributes.location.value;

        this.setState({
            location: {
                addressId: 0,
                addressLine1: "",
                addressLine2: null,
                city: "",
                displayOrder: "",
                email: "",
                fax: "",
                hub: "",
                id: 0,
                ip: "",
                isClosed: false,
                isClosedNotes: "",
                latitude: "",
                locationDescription: null,
                locationGroupId: 0,
                locationHoursNotes: "",
                locationPageDescription: "",
                locationPageMetaDescription: "",
                locationPageMetaTitle: "",
                locationPagePublished: false,
                locationPageTitle: "",
                locationPageUrl: "",
                longitude: "",
                name: "",
                pc: "",
                phone: "",
                reicoId: "",
                stateCode: "",
                stateId: 0,
                team: "",
                virtualTourLink: "",
                weekdayHours: "",
                weekendHours: "",
                zip: "",
                openingHours: {
                    weekdays: {
                        opens: "",
                        closes: ""
                    },
                    saturday: {
                        opens: "",
                        closes: ""
                    },
                    sunday: {
                        opens: "",
                        closes: ""
                    }
                }
            }
        });

        fetchLocation.bind(this)(id);

        chkReturn = setInterval(this.locationEditVerify, 100);
    }
    locationEditVerify() {
        if (this.props.location.updated || this.props.location.error) {
            if (this.props.location.updated) {
                this.setState({
                    editLocation: true,
                    editLocationMode: true
                });

                $('.navbar-static-top').css('z-index', 0);
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    locationCreate() {
        if (this.props.locations.fetching) return

        let emptyloc = {
            addressId: 0,
            addressLine1: "",
            addressLine2: null,
            city: "",
            displayOrder: "",
            email: "",
            fax: "",
            hub: "",
            id: 0,
            ip: "",
            isClosed: false,
            isClosedNotes: "",
            latitude: "",
            locationDescription: null,
            locationGroupId: 0,
            locationHoursNotes: "",
            locationPageDescription: "",
            locationPageMetaDescription: "",
            locationPageMetaTitle: "",
            locationPagePublished: false,
            locationPageTitle: "",
            locationPageUrl: "",
            longitude: "",
            name: "",
            pc: "",
            phone: "",
            reicoId: "",
            stateCode: "",
            stateId: 0,
            team: "",
            virtualTourLink: "",
            weekdayHours: "",
            weekendHours: "",
            zip: "",
            openingHours: {
                weekdays: {
                    opens: "",
                    closes: ""
                },
                saturday: {
                    opens: "",
                    closes: ""
                },
                sunday: {
                    opens: "",
                    closes: ""
                }
            }
        };

        this.setState({
            location: emptyloc,
            editLocation: false,
            editLocationMode: true
        });
    }

    updateLocation(e) {
        if (this.state.viewLocation) {
            this.cancelLocation()
            return
        }

        $('button.btn-primary').attr('disabled','disabled')

        let create = e.target.attributes.create.value;
        let location = { 
            locationPageDescription: this.state.location.locationPageDescription,
            addressId: 0,
            addressLine1: "",
            addressLine2: "",
            city: "",
            countryCode: "USA",
            displayOrder: 0,
            email: "",
            fax: "",
            latitude: 0,
            locationDescription: "",
            locationPageMetaDescription: "",
            locationPageMetaTitle: "",
            locationPageTitle: "",
            locationPageUrl: "",
            longitude: 0,
            phone: "",
            reicoId: 0,
            zip: ""
         };

        $('input, select, textarea').each(function () {
            if ($(this).val())
                location[$(this).attr('id')] = $(this).val() 

            if ($(this).attr('id') == 'name_2')
                location['name'] = $(this).val() 

            if ($(this).attr('id') == 'locationPagePublished')
                location['locationPagePublished'] = $(this).is(':checked') 

            if ($(this).attr('id') == 'isClosed')
                location['isClosed'] = $(this).is(':checked') 
        })

        this.updateLocationHours(location);

        if (create === 'true') {
            createLocation.bind(this)(location);
        }
        else {
            location.id = this.props.location.location.id
            updateLocation.bind(this)(location.id, location);
        }

        chkReturn = setInterval(this.closeLocation, 100);
    }

    updateLocationHours(location) {
        const weekdayOpenTime = formatTime($('#weekdayOpenTime').val(), false),
              weekdayCloseTime = formatTime($('#weekdayCloseTime').val(), true);

        if (weekdayOpenTime && weekdayOpenTime !== '' && weekdayCloseTime && weekdayCloseTime !== '') {
            location.weekdayHours = `Mon-Fri ${weekdayOpenTime} - ${weekdayCloseTime}`;
        }

        let weekendHoursString = '';
        const saturdayOpenTime = formatTime($('#saturdayOpenTime').val(), false),
              saturdayCloseTime = formatTime($('#saturdayCloseTime').val(), true),
              sundayOpenTime = formatTime($('#sundayOpenTime').val(), false),
              sundayCloseTime = formatTime($('#sundayCloseTime').val(), true);

        if (saturdayOpenTime === sundayOpenTime && saturdayCloseTime === sundayCloseTime) {
            if (saturdayOpenTime === '' || saturdayOpenTime.toLowerCase() === 'closed') {
                weekendHoursString = 'Closed';
            } else {
                weekendHoursString = `Sat-Sun ${saturdayOpenTime} - ${saturdayCloseTime}`;
            }
        } else {
            if (saturdayOpenTime !== '' && saturdayOpenTime.toLowerCase() !== 'closed') {
                weekendHoursString = `Sat ${saturdayOpenTime} - ${saturdayCloseTime}`;
            }

            if (sundayOpenTime !== '' && sundayCloseTime.toLowerCase() !== 'closed') {
                weekendHoursString += `Sun ${sundayOpenTime} - ${sundayCloseTime}`;
            }
        }

        location.weekendHours = weekendHoursString;
    }
    
    cancelLocation() {
        this.props.dispatch(errorLocation);

        this.setState({
            viewLocation: false,
            editLocationMode: false
        });

        $('button.btn-primary').removeAttr('disabled')

        this.props.dispatch(fetchLocationsList);
    }

    closeLocation() {
        if (this.props.location.updated || this.props.location.error) {
            $('button.btn-primary').removeAttr('disabled')

            if (this.props.location.updated) {
                this.cancelLocation();
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    pageDescriptionChange(editor) {
        editor.on('keyup', (e) => {
            let loc = this.state.location

            loc.locationPageDescription = e.target.innerHTML                
            this.setState({ location: loc })

            this.locationCheck()
        })

        editor.on('change', (e) => {
            let loc = this.state.location

            loc.locationPageDescription = e.level.content
            this.setState({ location: loc })

            this.locationCheck()
        })
    }

    render() {
        return (
            <div className="locations col-xs-12">
                <CommError error={this.props.location.error} onClose={this.errorLocationClear} />
                <CommError error={this.props.locations.error} onClose={this.fetchLocationErrorClear} />

                <ConfirmModal open={this.props.locations.noData} heading={"Locations"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                <div className="headWrapper">
                    <div className="locations">
                        <h1>Locations</h1>
                    </div>
                </div>

                <div id="srch">
                    <span>Search by Name:</span>
                    {
                        this.props.locations.fetching ?
                            <input id="name" disabled />
                        :
                            <input id="name" autocomplete="off" spellcheck="false" onChange={this.search} />
                    }
                    <button className="btn btn-primary pull-right" onClick={this.locationCreate}>+ Location</button>
                </div>

                <div className="tableWrapper"> 
                    {
                        this.props.locations.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }
                    <table className="lists table table-striped">
                        <thead>
                            <tr className="head">
                                <th>Name</th>
                                <th>Description</th>
                                <th>Menu Group</th>
                                <th>Menu Order</th>
                                <th>Status</th>
                                <th>Closed</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.locationsList ?
                                    this.props.locationsList.filter((location) => {
                                        if (this.state.nameSrch.length) {
                                            if (location.name.toLowerCase().startsWith(this.state.nameSrch)) {
                                                location.prefix = location.name.substring(0, this.state.nameSrch.length)
                                                location.suffix = location.name.substring(this.state.nameSrch.length)

                                                return true
                                            }
                                            else return false
                                        }
                                        else return true
                                    }).map((location, index) => {
                                        return <tr className={!location.locationPagePublished ? "body published" : "body"} key={index}>
                                            <td className="name" location={location.id} onClick={this.locationView}>
                                                {this.state.nameSrch.length ? <p><span className="srch">{location.prefix}</span><span>{location.suffix}</span></p> : location.name}
                                            </td>
                                            <td>{location.locationDescription}</td>
                                            <td>{location.locationGroupName}</td>
                                            <td>{location.displayOrder}</td>
                                            <td>{location.locationPagePublished ? "Published" : "Unpublished"}</td>
                                            <td>{location.isClosed ? "Yes" : "No"}</td>
                                            <td>
                                                <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                    <i className="fa fa-edit" location={location.id} onClick={this.locationEdit}></i>
                                                </OverlayTrigger>
                                            </td>
                                        </tr>
                                }) : null
                            }
                        </tbody>
                    </table>
                </div>

                <CreateEditLocation
                    errLocation={this.props.location}
                    errLocationClear={this.errorLocationClear}

                    curLocation={this.props.location.location}
                    tmpLocation={this.state.location}
                    locationGroups={this.props.locationGroups}

                    states={this.props.states}

                    create={this.state.editLocation}
                    isOpen={this.state.editLocationMode}
                    viewOnly={this.state.viewLocation}

                    onPageDescChange={this.pageDescriptionChange}

                    onAfterOpen={this.afterOpen}
                    onRequestClose={this.updateLocation}
                    onRequestCancel={this.cancelLocation}

                    locationCheck={this.locationCheck}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    location: state.location,
    locations: state.locations,
    states: state.states.states
});

export default connect(mapStateToProps)(Locations)